import React from 'react';
import { FUNDING_DEAL_STAGES, FUNDING_LENDER_TYPES, FUNDING_PRODUCT_TYPES } from '../../utils/funding/constants';

const selectClass = 'rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20';

const FundingDealFilters = ({
  search,
  stage,
  lenderType,
  productType,
  assignedUserId,
  onSearchChange,
  onStageChange,
  onLenderTypeChange,
  onProductTypeChange,
  onAssignedUserChange,
}) => (
  <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-5">
    <input
      type="search"
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      placeholder="Search client, lender, product..."
      className="rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20"
    />
    <select value={stage} onChange={(e) => onStageChange(e.target.value)} className={selectClass}>
      <option value="">All stages</option>
      {FUNDING_DEAL_STAGES.map((item) => <option key={item} value={item}>{item}</option>)}
    </select>
    <select value={lenderType} onChange={(e) => onLenderTypeChange(e.target.value)} className={selectClass}>
      <option value="">All lender types</option>
      {FUNDING_LENDER_TYPES.map((item) => <option key={item} value={item}>{item}</option>)}
    </select>
    <select value={productType} onChange={(e) => onProductTypeChange(e.target.value)} className={selectClass}>
      <option value="">All products</option>
      {FUNDING_PRODUCT_TYPES.map((item) => <option key={item} value={item}>{item}</option>)}
    </select>
    <input
      type="text"
      value={assignedUserId}
      onChange={(e) => onAssignedUserChange(e.target.value)}
      placeholder="Assigned user ID"
      className="rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20"
    />
  </div>
);

export default FundingDealFilters;
